import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { signOut } from "./authSlice/authSlice";
import { resetConsult } from "./consultSlice/consultSlice";
import { shootToast } from "codekit";
import QueryString from "qs";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_CIMA_ENDPOINT,
  mode: "cors",
  credentials: "include",
  timeout: process.env.REACT_APP_CIMA_TIMEOUT,
  prepareHeaders: (Headers, { getState }) => {
    const token = getState().persistedReducer.token;
    const module = getState().persistedReducer.moduleURL;
    const userReplace = getState().persistedReducer.userReplace;
    const isReplaceUser = getState().persistedReducer.isReplaceUser;
    Headers.set("Accept", "application/json");
    if (token) {
      Headers.set("Authorization", `Bearer ${token}`);
    }
    if (module && !Headers.has("modulecima")) {
      Headers.set("modulecima", module);
    }
    if (userReplace && userReplace !== "" && isReplaceUser) {
      Headers.set("userreplace", userReplace);
    }
    //Ver como cargo (administradores): el backend responde con las plantillas de ese cargo
    const cargoPreview = getState().persistedReducer.cargoPreview;
    if (cargoPreview?.CARIDXXX) {
      Headers.set("cargoview", String(cargoPreview.CARIDXXX));
    }
    return Headers;
  },
  paramsSerializer: (params) => {
    return QueryString.stringify(params);
  },
});

export const appendFormData = (form, data, parentKey) => {
  if (data == null) return;

  if (Array.isArray(data)) {
    data.forEach((v, i) =>
      appendFormData(form, v, parentKey ? `${parentKey}[${i}]` : `${i}`)
    );
  } else if (data instanceof Date) {
    form.append(parentKey, data.toISOString());
  } else if (typeof data === "object" && !(data instanceof File) && !(data instanceof Blob)) {
    Object.entries(data).forEach(([k, v]) => {
      const key = parentKey ? `${parentKey}[${k}]` : k;
      appendFormData(form, v, key);
    });
  } else {
    form.append(parentKey, data);
  }
};


let isSessionExpiredToastShowing = false;

const baseQueryWithLogOut = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  let autoHide = true;
  let text = "";
  let variant = "";

  const statusCode = result?.error?.status;
  const responseStatusCode = result?.meta?.response?.status;
  const isAgentRequest = args?.headers?.Modulecima === "Agentexx";

  switch (statusCode) {
    case "TIMEOUT_ERROR":
      text = "No se pudo conectar con la plataforma. Por favor, intenta de nuevo más tarde.";
      variant = "error";
      break;
    case 401:
      api.dispatch(signOut());
      if (!isSessionExpiredToastShowing) {
        isSessionExpiredToastShowing = true;
        text = "Tu sesión en CIMA ha expirado. Por favor, inicia sesión nuevamente.";
        variant = "error";
        setTimeout(() => {
          isSessionExpiredToastShowing = false;
        }, 6000);
      }
      break;
    case 403:
    case 405:
    case 422:
    case 500:
      const errors = result?.error?.data;
      if (errors?.message) {
        text = errors?.message;
      } else if (errors.errors) {
        const errorObject = errors.errors;
        const errorsProperties = Object.getOwnPropertyNames(errorObject);
        errorsProperties.forEach((property) => {
          if (property !== "exception") {
            const propertyValue = errorObject[property];
            if (Array.isArray(propertyValue)) {
              const mappedErrors = propertyValue.slice(0, 2).map((item) => {
                if (item && typeof item === "object") {
                  return item.message || JSON.stringify(item);
                }
                return String(item);
              });
              let detailText = mappedErrors.join("\n");
              if (propertyValue.length > 2) {
                detailText += "\n...";
              }
              text += detailText;
            } else if (propertyValue && typeof propertyValue === "object") {
              text += propertyValue.message || JSON.stringify(propertyValue);
            } else {
              text +=
                propertyValue !== "Invalid Query"
                  ? propertyValue
                  : "Se presentaron problemas en la consulta";
            }
            text += "\n";
          } else {
            text += errorObject[property].includes("Duplicate entry")
              ? "La informacion que intenta guardar ya existe"
              : errorObject[property];
          }
        });
      } else {
        text = "Error no identificado";
      }
      variant = "error";
      break;
    case 413:
      text    = "Lo sentimos el tamaño de la solicitud excede el límite permitido. Intenta de nuevo con menos información.";
      variant = "error";
      break;
    default:
      break;
  }

  switch (responseStatusCode) {
    case 201:
      //Limpio filtros consulta inducida ???
      api.dispatch(resetConsult());

      text = "La informacion ha sido cargada con exito!";
      variant = "success";
      break;
    case 200:
      const method = result?.meta?.request?.method;
      variant = "success";

      if (method === "PUT") {
        text = "El registro ha sido actualizado con exito!";
      }

      if (method === "DELETE") {
        text = result.data?.data?.message;
      }

      if(method === "POST") {
       text = "La informacion ha sido cargada con exito!";
      }

      break;
    default:
      break;
  }

  if (text !== "" && !isAgentRequest) {
    shootToast({
      variant,
      text,
      duration: 5000,
      autoHide,
    });
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithLogOut,
  endpoints: (builder) => ({}),
  tagTypes: ["Create", "Consult", "Notification", "Dashestx"],
});
